import { createFileRoute } from "@tanstack/react-router";
import AdminCRM360 from "@/pages/admin/AdminCRM360";

export const Route = createFileRoute("/admin/crm360")({
  component: AdminCRM360,
});
